const isProd = !!window.location.hostname.match(/^(manager\.)?baosystems/);
const api = {
  base: `${isProd ? process.env.REACT_APP_API_BASE_URL : process.env.REACT_APP_API_BASE_URL_TEST}${process.env.REACT_APP_API_URL_PATH}`
}

export default api
